import { useEffect } from "react";
import Drawer from "../../../../drawer/Drawer";
import ManageTestimonial from "../ManageTestimonial";

const ManageTestimonialDrawer = ({ open, close = () => {}, getResponse = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update Testimonial" : "Add Testimonial"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
    >
      <ManageTestimonial getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageTestimonialDrawer;
